import RegistrationView from './containers/RegistrationView';
export default RegistrationView;

export {uiDataRegistrationView} from './reducers/RegistrationView';
